<template>
  <v-content>
    <v-container :fluid="this.$vuetify.breakpoint.mdAndDown">
      <template v-if="$store.state.adminToken">
        <admin-nav />

        <v-card class="mb-4 pa-3">
          <v-layout align-center justify-space-between>
            <span class="title grey--text text--darken-2">Kiosk Status</span>
            <v-btn icon small @click="fetchKioskStatus" :loading="loading">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-layout>

          <v-divider class="my-2"></v-divider>

          <v-layout wrap>
            <div v-if="kiosks.length === 0" class="caption grey--text pa-2">
              No kiosks have reported in yet.
            </div>

            <v-chip
              v-for="kiosk in kiosks"
              :key="kiosk.id"
              :color="
                isOnline(kiosk.last_seen) ? 'green lighten-4' : 'red lighten-4'
              "
              :text-color="
                isOnline(kiosk.last_seen) ? 'green darken-2' : 'red darken-2'
              "
              class="ma-2"
              label
            >
              <v-avatar left>
                <v-icon>{{
                  isOnline(kiosk.last_seen) ? "check_circle" : "error"
                }}</v-icon>
              </v-avatar>
              <strong>{{ kiosk.id }}</strong>
              <span class="caption ml-2"
                >({{ formatTimeAgo(kiosk.last_seen) }})</span
              >
            </v-chip>
          </v-layout>
        </v-card>
        <v-card class="pa-4">
          <router-view />
        </v-card>
      </template>
      <login v-else />
    </v-container>
  </v-content>
</template>

<script>
import AdminNav from "@/components/AdminNav.vue";
import Login from "@/components/Login.vue";
import moment from "moment"; // You might need: npm install moment

export default {
  components: {
    AdminNav,
    Login
  },
  data() {
    return {
      loading: false,
      kiosks: [],
      // Auto-refresh interval
      pollInterval: null
    };
  },
  computed: {},
  watch: {
    "$store.state.adminToken"(newVal) {
      if (newVal && !this.pollInterval) {
        this.fetchKioskStatus();
        this.pollInterval = setInterval(this.fetchKioskStatus, 1200000);
      }
    }
  },
  mounted() {
    // Only fetch if already logged in (e.g. navigating back to this page mid-session)
    if (this.$store.state.adminToken) {
      this.fetchKioskStatus();
      this.pollInterval = setInterval(this.fetchKioskStatus, 1200000);
    }
  },
  beforeDestroy() {
    if (this.pollInterval) clearInterval(this.pollInterval);
  },
  methods: {
    async fetchKioskStatus() {
      this.loading = true;
      try {
        // REPLACE with your actual API endpoint that returns [{ id: 'lobby', last_seen: '2023-10-27T10:00:00Z' }]
        const response = await fetch("/api/kiosks/status", {
          headers: { Authorization: `Bearer ${this.$store.state.adminToken}` }
        });
        this.kiosks = await response.json();
      } catch (err) {
        console.error("Failed to load kiosk status", err);
      } finally {
        this.loading = false;
      }
    },
    isOnline(lastSeen) {
      // Threshold: 60 minutes (if heartbeat is older than this, it's offline)
      const threshold = 60;
      const diffMinutes = moment().diff(moment(lastSeen), "minutes");
      return diffMinutes < threshold;
    },
    formatTimeAgo(date) {
      return moment(date).fromNow();
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";
</style>
